import { navigate } from 'gatsby-link';

export const useRedirect = (shouldRedirect, redirectTo) => {
    if (shouldRedirect && typeof window !== 'undefined') {
        navigate(redirectTo);
    }
};
